export const UPGRADE_REQUIRED_EVENT = 'upgrade-required';

export const attachUpgradeInterceptor = (axiosInstance) => {
  axiosInstance.interceptors.response.use(undefined, (error) => {
    if (
      error.response &&
      error.response.status === 403 &&
      error.response.data?.code === 'UPGRADE_REQUIRED'
    ) {
      window.dispatchEvent(
        new CustomEvent(UPGRADE_REQUIRED_EVENT, {
          detail: error.response.data,
        })
      );
    }
    return Promise.reject(error);
  });
};
